import React from 'react'
import { Redirect, Route, useLocation } from 'react-router'
import { useAuth } from '../auth/useAuth';

export const PublicRoute = ( { component: Component, ...rest }) => {

    const auth = useAuth();
    const location = useLocation();
    
    return (
        <Route {...rest}>{ !auth.isLogged() ? (<Component />) : (<Redirect to={{ pathname: "/", state: { from: location }}} />) }</Route>
    )
}
